import React from 'react';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { messages } from '../BlockOffTime.messages';

const ConfirmStaffBlockModal = () => (
  <Confirm
    title={<Message message={messages.confirmStaffBlockModal.title} />}
    cancelNode={<Message message={messages.confirmStaffBlockModal.cancel} />}
    acceptNode={<Message message={messages.confirmStaffBlockModal.confirm} />}>
    <Message message={messages.confirmStaffBlockModal.body} values={{ strong: text => <strong>{text}</strong> }} />
  </Confirm>
);

export default ConfirmStaffBlockModal;
